module.exports = __webpack_public_path__ + "static/media/IMG-34.df17612e.jpg";